/**
 * Created by akirilyuk on 11/14/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/ticketCreateView.tmpl"),
        InputField = require("ui/input-field/InputField"),
        TextField = require("ui/textarea-field/TextareaField"),
        Bubble = require("ui/bubble/Bubble"),
        DateTimePickerBubbleView = require("connection-views/ticketTab/widgets/DateTimePickerBubbleView"),
        ServiceIncidentView = require("connection-views/ticketTab/ServiceIncidentView"),
        Button = require("ui/button/Button"),
        ArticleSuggestionsView = require("connection-views/ticketTab/ArticleSuggestionsView"),
        AttachmentsView = require("connection-views/ticketTab/extendedList/TicketAttachmentView"),
        AttachmentUpload = require("connection-views/ticketTab/extendedList/AttachmentUploadInput"),
        AttachmentsCollection = require("connection-collections/ticketTab/AttachmentsCollection"),
        CheckBox = require("ui/checkbox/Checkbox"),
        Dropdown = require("ui/dropdown/Dropdown"),
        Loader = require("ui/loader/Loader"),
        HtmlSanitizerUtils = require("HtmlSanitizerUtils"),
        SDKView = require("connection-views/ticketTab/createCaseSubViews/SDKView"),
        EmptyView = require("connection-views/ticketTab/createCaseSubViews/EmptyView"),
        BotView = require("connection-views/ticketTab/createCaseSubViews/BotView"),
        TicketCreateView = {};

    var PRECEEDING_DROPDOWN_MENU_ITEMS = {
        NO: "no",
        YES: "yes"
    };

    var SEVERITY_DROPDOWN_MENU_ITEMS = {
        CRITICAL: "Critical",
        HIGH: "High",
        MEDIUM: "Medium"
    };

    var CASE_TOPIC_DROPDOWN_ITEMS = {
        GENERAL: "General",
        BOT: "Bot",
        SDK: "SDK"
        // this is commented out, we will release it gradually
        //API: "API",
        //AGENT: "AgentWorkspace",
        //CAMPAIGN: "Campaign",
        //Reports: "Reports",
    };

    var CASE_PLATFORM_DROPDOWN_ITEMS = {
        CHAT: "Chat",
        MSG: "Messaging"
    };

    var INPUT_LIMIT = {
        DESCRIPTION: 1000,
        REPLICATION: 1000,
        SCOPE: 700,
        CHANGES: 600,
        PHONE: 40,
        SUBJECT: 255
    };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketCreateView = Marionette.ItemView.extend({
            template: template,
            className: 'ticket-create-view',
            events: {
                "mouseenter .case-issue-noticed-container": "_onInputCLick"
            },
            ui: {
                pageContentContainer: ".page-view-container",
                attachmentsRegion: ".case-attachments-region .data-container",
                attachmentsUpload: ".case-attachments-region .case-attachments-upload",
                caseSubject: ".case-subject-container .input-container",
                articleSuggestionsView: ".search-results-wrapper",
                caseDescription: ".case-description-container .input-container",
                caseReplicationSteps: ".case-replication-steps-container .input-container",
                caseScopeOfImpact: ".case-scope-container .input-container",
                caseFirstNoticed: ".case-issue-noticed-container .input-container",
                casePrecedingChangesContainer: ".case-preceding-changes-container",
                casePrecedingChangesInput: ".case-preceding-changes-container .input-container",
                casePrecedingChangesActionMenu: ".case-preceding-changes-dropdown .action-menu",
                accountId: ".case-accountId-container .input-container",
                accountName: ".case-accountName-container .input-container",
                contactName: ".case-contactName-container .input-container",
                contactEmail: ".case-contactEmail-container .input-container",
                contactPhone: ".case-contactPhone-container .input-container",
                checkBoxContainer: ".checkbox-container .input-container",
                cancelButton: ".cancel-button",
                saveButton: ".save-button",
                loaderContainer: ".loader-container",
                caseDescriptionTextArea: "textarea",
                chatWithUsButton: ".chat-with-us",
                serviceInterruptionContainer: ".service-interruption-container",
                caseSeverityActionMenuContainer: ".case-severity-dropdown",
                caseSeverityActionMenu: ".case-severity-dropdown .action-menu",
                caseTopicActionMenu: ".case-topic-dropdown .action-menu",
                casePlatformActionMenu: ".case-platform-dropdown .action-menu",
                createCaseSubView: ".create-case-sub-view"
            },
            uiComponents: {
                serviceIncidentView: {
                    type: ServiceIncidentView,
                    options: {
                        el: "view.ui.serviceInterruptionContainer"
                    }
                },
                articleSuggestionsView: {
                    type: ArticleSuggestionsView,
                    options: {
                        el: "view.ui.articleSuggestionsView",
                        loaded: false
                    }
                },
                chatWithUsButton: {
                    type: Button,
                    options: {
                        el: "view.ui.chatWithUsButton",
                        permutation: Button.PERMUTATION.BLUELINK_TEXT_ALIGN
                    },
                    events: {
                        "click": "_onChatWithUs"
                    }
                },
                attachmentsRegion: {
                    type: AttachmentsView,
                    options: {
                        el: "view.ui.attachmentsRegion",
                        collection: "view._getAttachmentsCollection",
                        doFilter: true
                    }
                },
                attachmentsUpload: {
                    type: AttachmentUpload,
                    options: {
                        el: "view.ui.attachmentsUpload",
                        collection: "view._getAttachmentsCollection"
                    }
                },
                caseSubject: {
                    type: InputField,
                    options: {
                        el: "view.ui.caseSubject",
                        permutation: InputField.Permutation.B
                    }
                },
                caseDescription: {
                    type: TextField,
                    options: {
                        el: "view.ui.caseDescription",
                        permutation: InputField.Permutation.B,
                        maxChars: INPUT_LIMIT.DESCRIPTION
                    }
                },
                caseReplicationSteps: {
                    type: TextField,
                    options: {
                        el: "view.ui.caseReplicationSteps",
                        maxChars: INPUT_LIMIT.REPLICATION
                    }
                },
                caseScopeOfImpact: {
                    type: TextField,
                    options: {
                        el: "view.ui.caseScopeOfImpact",
                        permutation: InputField.Permutation.C,
                        maxChars: INPUT_LIMIT.SCOPE
                    }
                },
                caseFirstNoticed: {
                    type: InputField,
                    options: {
                        el: "view.ui.caseFirstNoticed",
                        placeholder: LE.translator.translate("LEConnection.cases.createView.firstNoticedDate"),
                        readonly: true
                    }
                },

                casePrecedingChangesActionMenu: {
                    type: Dropdown,
                    options: {
                        el: "view.ui.casePrecedingChangesActionMenu",
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        items: "view._getPrecedingDropdownMenuCollection",
                        permutation: Dropdown.PERMUTATION.MID_SMALL_1
                    },
                    events: {
                        "change": "_onPrecedingDropdownMenuSelected"
                    }
                },
                casePrecedingChangesInput: {
                    type: TextField,
                    options: {
                        el: "view.ui.casePrecedingChangesInput",
                        permutation: InputField.Permutation.E
                    }
                },
                accountId: {
                    type: InputField,
                    options: {
                        el: "view.ui.accountId",
                        permutation: InputField.Permutation.B
                    }
                },
                accountName: {
                    type: InputField,
                    options: {
                        el: "view.ui.accountName",
                        permutation: InputField.Permutation.B
                    }
                },
                contactName: {
                    type: InputField,
                    options: {
                        el: "view.ui.contactName",
                        permutation: InputField.Permutation.B
                    }
                },
                contactEmail: {
                    type: InputField,
                    options: {
                        el: "view.ui.contactEmail",
                        permutation: InputField.Permutation.B
                    }
                },
                contactPhone: {
                    type: InputField,
                    options: {
                        el: "view.ui.contactPhone",
                        permutation: InputField.Permutation.B
                    }
                },
                checkBoxVisibility: {
                    type: CheckBox,
                    options: {
                        el: "view.ui.checkBoxContainer"
                    }
                },

                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSave"
                    }
                },
                caseSeverityActionMenu: {
                    type: Dropdown,
                    options: {
                        el: "view.ui.caseSeverityActionMenu",
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        items: "view._getSeverityDropdownMenuCollection",
                        permutation: Dropdown.PERMUTATION.MID_SMALL_1
                    },
                    events: {
                        "change": "_onCaseSeveritySelected"
                    }
                },

                caseTopicActionMenu: {
                    type: Dropdown,
                    options: {
                        el: "view.ui.caseTopicActionMenu",
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        items: "view._getTopicDropdownMenuCollection",
                        permutation: Dropdown.PERMUTATION.MID_SMALL_1
                    },
                    events: {
                        "change": "_onCaseTopicSelected"
                    }
                },

                casePlatformActionMenu: {
                    type: Dropdown,
                    options: {
                        el: "view.ui.casePlatformActionMenu",
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        items: "view._getPlatformDropdownMenuCollection",
                        permutation: Dropdown.PERMUTATION.MID_SMALL_1
                    },
                    events: {
                        "change": "_onCasePlatformSelected"
                    }
                }
            },

            initialize: function (options) {
                this.model = options.model;
                this.channel = options.channel;
                this.storageModel = options.storageModel;
                this.canAddSeverity = options.context.canAddSeverity();
            },

            onRender: function () {
                this._initContactValues();
                this._initValuesFromStorage();
                if (this.canAddSeverity) {
                    this._showSeverityDropdownMenu();
                }
                this._bindEvents();
            },

            _initContactValues: function () {
                this._initCaseOwnerAccountId();
                this._initCaseAccountName();
                this._initContactName();
                this._initContactEmail();
            },

            _initValuesFromStorage: function () {
                this._initCaseSubject(this.storageModel.getSubject());
                this._initCaseDescription(this.storageModel.getDescription());
                this._initPreceedingChanges(this.storageModel.getPreceedingChanges());
                this._initScope(this.storageModel.getScope());
                this._initVisibility(this.storageModel.getVisibility());
                this._initReplication(this.storageModel.getReplication());
                this._initFirstNoticed(this.storageModel.getFirstNoticed());
                this._initContactPhone(this.storageModel.getPhone());
                this._initContactName(this.storageModel.getName());
                this._initContactEmail(this.storageModel.getEmail());
                if (this.canAddSeverity) {
                    this._initSeverityDropdown(this.storageModel.getCaseSeverity());
                }
                this._initCaseTopicDropdown(this.storageModel.getCaseTopic());
                this._initCasePlatformDropdown(this.storageModel.getCasePlatform());
            },

            _bindEvents: function () {
                this.listenTo(this.channel.vent, "TicketCreateView::display:searchResults", this._showArticleSuggestionsCollection);
                this.listenTo(this.uiComponents.caseFirstNoticed, InputField.TRIGGERING.ONFOCUS, this._onDateSelectFocus);
                this.listenTo(this.channel.vent, "date::selected", this._onDateSelected);
                this.listenTo(this.channel.vent, "clicked::outside", this._onDateClickedOutside);
                //bind scroll event manually since marionette vents binding won't work
                $(this.ui.pageContentContainer).scroll(_.bind(this._onScroll, this));
                //listeners for storage saving
                this.listenTo(this.uiComponents.caseSubject, InputField.TRIGGERING.ONBLUR, this._onSubjectBlur);
                this.listenTo(this.uiComponents.caseDescription, "blur", this._onDescriptionBlur);
                this.listenTo(this.uiComponents.casePrecedingChangesInput, "blur", this._onPrecedingChangesBlur);
                this.listenTo(this.uiComponents.caseScopeOfImpact, "blur", this._onScopeOfImpactBlur);
                this.listenTo(this.uiComponents.caseReplicationSteps, "blur", this._onReplicationBlur);
                this.listenTo(this.uiComponents.checkBoxVisibility, CheckBox.TRIGGERING.CHANGE, this._onCheckBoxChanged);
                this.listenTo(this.uiComponents.contactPhone, InputField.TRIGGERING.ONBLUR, this._onContactPhoneBlur);
                this.listenTo(this.uiComponents.contactEmail, InputField.TRIGGERING.ONBLUR, this._onContactEmailBlur);
                this.listenTo(this.uiComponents.contactName, InputField.TRIGGERING.ONBLUR, this._onContactNameBlur);
            },

            /*
             Event handlers
             */

            _onScroll: function () {
                this._closeDateTimePickerBubble();
            },

            _onContactPhoneBlur: function () {
                var text = this._getContactPhone();
                if (text && text.length > 0) {
                    this.storageModel.setPhone(text);
                }
            },

            _onContactEmailBlur: function () {
                var text = this._getContactEmail();
                if (text && text.length > 0) {
                    this.storageModel.setEmail(text);
                }
            },

            _onContactNameBlur: function () {
                var text = this._getContactName();
                if (text && text.length > 0) {
                    this.storageModel.setName(text);
                }
            },

            _onDescriptionBlur: function () {
                var text = this._getSanitizedValue(this.uiComponents.caseDescription);
                if (text && text.length > 0) {
                    this.storageModel.setDescription(text);
                }
            },

            _onFirstNoticedChange: function () {
                var text = this._getSanitizedValue(this.uiComponents.caseFirstNoticed);
                this.storageModel.setFirstNoticed(text);
            },

            _onPrecedingChangesBlur: function () {
                var text = this._getSanitizedValue(this.uiComponents.casePrecedingChangesInput);
                if (text && text.length > 0) {
                    this.storageModel.setPreeceedingChanges(text);
                }
            },

            _onScopeOfImpactBlur: function () {
                var text = this._getSanitizedValue(this.uiComponents.caseScopeOfImpact);
                if (text && text.length > 0) {
                    this.storageModel.setScope(text);
                }
            },

            _onReplicationBlur: function () {
                var text = this._getSanitizedValue(this.uiComponents.caseReplicationSteps);
                if (text && text.length > 0) {
                    this.storageModel.setReplication(text);
                }
            },

            _onCheckBoxChanged: function () {
                var status = this.uiComponents.checkBoxVisibility.isChecked();
                this.storageModel.setVisibility(status);
            },

            _onDateSelected: function (date) {
                this.uiComponents.caseFirstNoticed.setValue(date.toString());
                this._onFirstNoticedChange(date.toString());
                this._closeDateTimePickerBubble();
            },

            _onDateSelectFocus: function () {
                this._createDateTimePickerBubble();
            },

            _onDateClickedOutside: function (element) {
                //this is really ugly, but somehow the header of the datepicker widget isn't a child note of the datepicker, so we cant check if its a child element
                //with Node.contains
                var headerElements = ["ui-datepicker-prev ui-corner-all ui-state-hover ui-datepicker-prev-hover",
                    "ui-icon ui-icon-circle-triangle-w",
                    "ui-icon ui-icon-circle-triangle-e",
                    "ui-datepicker-next ui-corner-all ui-state-hover ui-datepicker-next-hover"];
                if (this.uiComponents.dateTimePickerBubble) {
                    if (!this.uiComponents.caseFirstNoticed.$el[0].contains(element.target) && this.uiComponents.caseFirstNoticed != element.target &&
                        !this.uiComponents.dateTimePickerBubble.$el[0].contains(element.target) && !_.contains(headerElements, element.target.className)) {
                        this._closeDateTimePickerBubble();
                    }
                }
            },

            _onChatWithUs: function () {
                this._openChatTab();
            },

            _onCancel: function () {
                this._closeWindow();
            },

            _onSubjectBlur: function () {
                var searchTerm = this._getSubject();
                //save search term in model
                this.storageModel.setSubject(searchTerm);
                if (searchTerm.replace(" ", "").length > 0) {
                    this._showArticleSuggestions();
                    this.uiComponents.articleSuggestionsView.setLoader();
                    this._triggerArticleSearch(searchTerm.toLowerCase());
                } else {
                    this.uiComponents.articleSuggestionsView.hideView();
                }
            },

            _onSave: function () {
                this._collectInformation();
            },

            _onPrecedingDropdownMenuSelected: function (stuff, stufff, selectedItemId) {
                switch (selectedItemId.selectedKey) {
                    case PRECEEDING_DROPDOWN_MENU_ITEMS.NO:
                        this._hidePrecedingChangesTextField();
                        break;
                    case PRECEEDING_DROPDOWN_MENU_ITEMS.YES:
                        this._showPrecedingChangesTextField();
                        break;
                    default:
                        break;
                }
            },

            _onCaseSeveritySelected: function (stuff, stufff, selectedItemId) {
                if (this.canAddSeverity) {
                    this.storageModel.setCaseSeverity(selectedItemId.selectedKey);
                }
            },

            _onCaseTopicSelected: function (stuff, stufff, selectedItemId) {
                this.storageModel.setCaseTopic(selectedItemId.selectedKey);
                this._displaySubView(selectedItemId.selectedKey);
            },

            _onCasePlatformSelected: function (stuff, stufff, selectedItemId) {
                this.storageModel.setCasePlatform(selectedItemId.selectedKey);
            },

            _displaySubView: function (viewName) {
                switch (viewName) {
                    case CASE_TOPIC_DROPDOWN_ITEMS.SDK:
                        this.createCaseSubView = new SDKView({
                            attachmentsCollection: this._getAttachmentsCollection(),
                            storageModel: this._getStorageModel()
                        });
                        break;
                    case CASE_TOPIC_DROPDOWN_ITEMS.BOT:
                        this.createCaseSubView = new BotView({attachmentsCollection: this._getAttachmentsCollection()});
                        break;
                    default:
                        this.createCaseSubView = new EmptyView();
                        break;
                }
                // I really dont know why, but somehow with this approach i can add the mainsubview to our html and render it
                this.listenToOnce(this.createCaseSubView, "render", function () {
                    $(this.ui.createCaseSubView).html(this.createCaseSubView.el);
                });
                this.createCaseSubView.render();
            },

            /*
             Fields initialization
             */

            _initCaseOwnerAccountId: function () {
                var accountId = this.model.getSiteId();
                if (accountId && accountId.length > 0 && this.getIsRendered()) {
                    this.uiComponents.accountId.setValue(this.model.getSiteId());
                    this.uiComponents.accountId.setReadonly(true);
                    this.uiComponents.accountId.setEnabled(false);
                }
                return this.uiComponents.accountId;
            },

            _initCaseAccountName: function () {
                var accountName = this.model.getAccountName();
                if (accountName && accountName.length > 0 && this.getIsRendered()) {
                    this.uiComponents.accountName.setValue(this.model.getAccountName());
                    this.uiComponents.accountName.setReadonly(true);
                    this.uiComponents.accountName.setEnabled(false);
                }
                return this.uiComponents.accountName;
            },

            _initContactName: function () {
                var contactName = this.model.getContactName();
                if (contactName && contactName.length > 0 && this.getIsRendered()) {
                    this.uiComponents.contactName.setValue(this.model.getContactName());
                    this.uiComponents.contactName.setReadonly(true);
                    this.uiComponents.contactName.setEnabled(false);
                }
                return this.uiComponents.contactName;
            },

            _initContactEmail: function () {
                var contactEmail = this.model.getContactEmail();
                if (contactEmail && contactEmail.length > 0 && this.getIsRendered()) {
                    this.uiComponents.contactEmail.setValue(this.model.getContactEmail());
                    this.uiComponents.contactEmail.setReadonly(true);
                    this.uiComponents.contactEmail.setEnabled(false);
                }
                return this.uiComponents.contactEmail;
            },

            _initCaseSubject: function (value) {
                if (value && value.length > 0 && this.getIsRendered()) {
                    this.uiComponents.caseSubject.setValue(value);
                }
            },

            _initCaseDescription: function (value) {
                if (value && value.length > 0 && this.getIsRendered()) {
                    this.uiComponents.caseDescription.setValue(value);
                }
            },

            _initScope: function (value) {
                if (value && value.length > 0 && this.getIsRendered()) {
                    this.uiComponents.caseScopeOfImpact.setValue(value);
                }
            },

            _initReplication: function (value) {
                if (value && value.length > 0 && this.getIsRendered()) {
                    this.uiComponents.caseReplicationSteps.setValue(value);
                }
            },

            _initVisibility: function (value) {
                if (value && this.getIsRendered()) {
                    this.uiComponents.checkBoxVisibility.setCheckedState(value);
                }
            },

            _initFirstNoticed: function (value) {
                if (this.getIsRendered()) {
                    if (value && value.length > 0) {
                        this.uiComponents.caseFirstNoticed.setValue(value);
                    } else {
                        this.uiComponents.caseFirstNoticed.setValue(new Date().toString());
                    }
                }
            },

            _initContactPhone: function (value) {
                if (value && value.length > 0) {
                    this.uiComponents.contactPhone.setValue(value);
                }
            },

            _initPreceedingChanges: function (value) {
                if (value && value.length > 0) {
                    this.uiComponents.casePrecedingChangesActionMenu.setSelection(PRECEEDING_DROPDOWN_MENU_ITEMS.YES);
                    this._showPrecedingChangesTextField();
                    this.uiComponents.casePrecedingChangesInput.setValue(value);
                }
            },

            _initSeverityDropdown: function (value) {
                if (value && value.length > 0) {
                    this.uiComponents.caseSeverityActionMenu.setSelection(value);
                }else{
                    this.uiComponents.caseSeverityActionMenu.setSelection(SEVERITY_DROPDOWN_MENU_ITEMS.MEDIUM);
                }
            },

            _initCaseTopicDropdown: function (value) {
                if (value && value.length > 0) {
                    this.uiComponents.caseTopicActionMenu.setSelection(value);
                    this._displaySubView(value);
                } else {
                    //display this as first selected value
                    this.storageModel.setCaseTopic(CASE_TOPIC_DROPDOWN_ITEMS.GENERAL);
                    this._displaySubView(CASE_TOPIC_DROPDOWN_ITEMS.GENERAL);
                }
            },

            _initCasePlatformDropdown: function (value) {
                if (value && value.length > 0) {
                    this.uiComponents.casePlatformActionMenu.setSelection(value);
                }
            },

            _createDateTimePickerBubble: function () {
                var dateTimeValue = this.uiComponents.caseFirstNoticed.getValue();
                var currentDate = null;
                if (dateTimeValue && dateTimeValue.length > 0) {
                    currentDate = new Date(dateTimeValue);
                }
                if (!this.uiComponents.dateTimePickerBubble) {
                    this.uiComponents.host$.createAndRender("dateTimePickerBubble", {
                        type: Bubble,
                        options: {
                            targetControl: this.ui.caseFirstNoticed,
                            contentView: new DateTimePickerBubbleView({
                                channel: this.channel,
                                initDate: currentDate
                            }),
                            position: Bubble.POSITION.BOTTOM,
                            align: Bubble.ALIGN.LEFT,
                            showCloseButton: false,
                            preventCloseOnBubbleMouseEnter: false,
                            theme: Bubble.THEME.LIGHT
                        }
                    });
                }
            },

            _closeDateTimePickerBubble: function () {
                if (this.uiComponents.dateTimePickerBubble) {
                    //remove focus from
                    this.uiComponents.caseFirstNoticed.blurInput();
                    this.uiComponents.dateTimePickerBubble.close(true);
                }
            },
            /*
             Fields validation
             */

            _getMandatoryFields: function () {
                var mandatory = [];
                mandatory.push(this.uiComponents.caseDescription);
                mandatory.push(this.uiComponents.caseReplicationSteps);
                mandatory.push(this.uiComponents.caseScopeOfImpact);
                mandatory.push(this.uiComponents.caseFirstNoticed);
                if (this._precedingChangesAreSelected()) {
                    mandatory.push(this.uiComponents.casePrecedingChangesInput);
                }
                return mandatory;
            },

            _getDropdownFields: function () {
                var dropdowns = [];
                dropdowns.push(this.uiComponents.caseTopicActionMenu);
                dropdowns.push(this.uiComponents.casePlatformActionMenu);
                return dropdowns;
            },

            _getContactFields: function () {
                var contact = [];
                contact.push(this.uiComponents.accountName);
                contact.push(this.uiComponents.accountId);
                contact.push(this.uiComponents.contactEmail);
                contact.push(this.uiComponents.contactName);
                return contact;
            },

            _precedingChangesAreSelected: function () {
                return !($(this.ui.casePrecedingChangesContainer).hasClass("hide")); // no class hide -> preceding changes are selected
            },

            _validateFields: function () {
                var mandatoryFields = this._getMandatoryFields();
                var contactFields = this._getContactFields();
                var subValid = this._validateSubject();
                var mandatoryValid = this._validateMandatoryFields(mandatoryFields);
                var contactValid = this._validateContactFields(contactFields);
                var subViewValid = (this.createCaseSubView && _.isFunction(this.createCaseSubView.isValid)) ? this.createCaseSubView.isValid() : true;
                return subValid && mandatoryValid && contactValid && subViewValid;
            },

            _validateSubject: function () {
                return this._validateAndDisplayError([this.uiComponents.caseSubject], LE.translator.translate("LEConnection.cases.createView.error.MandatoryField"));
            },

            _validateMandatoryFields: function (fields) {
                return this._validateAndDisplayError(fields, LE.translator.translate("LEConnection.cases.createView.error.MandatoryField"));
            },

            _validateContactFields: function (fields) {
                return this._validateAndDisplayError(fields, LE.translator.translate("LEConnection.cases.createView.error.ContactField"));
            },

            _validateAndDisplayError: function (fields, errorMsg) {
                var valid = true;
                var that = this;
                _.each(fields, function (field) {
                    var fieldValue = that._getSanitizedValue(field);
                    if (_.isNull(fieldValue) || fieldValue.length === 0) {
                        valid = false;
                        if (_.isFunction(field.setError)) {
                            field.setError(true, errorMsg);
                        }
                    }
                });
                return valid;
            },

            _getSanitizedValue: function (field) {
                return this._removeCSVInjectionAttempt(HtmlSanitizerUtils.sanitizeHtml(field.getValue()).cleanText);
            },

            _removeCSVInjectionAttempt: function (text) {
                if(_.isString(text) && text.length>0){
                    return text.replace(/^(\-|\+|\*|\@)*/gm,'');
                }
                return text;
            },

            _generateDescriptionFromFields: function () {
                var mandatoryFields = this._getMandatoryFields();
                var dropdownFields = this._getDropdownFields();
                var description = "";
                var that = this;
                var globIndex = 0;
                _.each(dropdownFields, function (field) {
                     globIndex += 1;
                     description += (globIndex).toString() + "." + that._getLabelAndTextFromDropdownMenu(field) + "\n";
                     description += "_______" + "\n";
                });
                _.each(mandatoryFields, function (field) {
                    if (!($(field).hasClass("subject"))) {//add all fields except subject
                        globIndex += 1;
                        description += (globIndex).toString() + "." + that._getLabelAndTextFromPropertyContainer(field) + "\n";
                        description += "_______" + "\n";
                    }
                });
                if (this._getContactPhone().length > 0) {
                    globIndex += 1;
                    description += (globIndex).toString() + "." + this._getLabelAndTextFromPropertyContainer(this.uiComponents.contactPhone) + "\n";

                }
                if(this.createCaseSubView && _.isFunction(this.createCaseSubView.getTextFieldsValuesInConcatString) && _.isFunction(this.createCaseSubView.getViewName)){
                    description += "_______" + "\n";
                    globIndex += 1;
                    description += (globIndex).toString() + "." + this.createCaseSubView.getViewName() + "\n" + this.createCaseSubView.getTextFieldsValuesInConcatString();
                }
                return description;
            },

            _collectInformation: function () {
                if (this._validateFields()) {
                    this.model.setSummary(this._getSubject());
                    this.model.setDetails(this._generateDescriptionFromFields());
                    this.model.setVisibility(this._getVisibility());
                    this.model.setContactPhone(this._getContactPhone());
                    this.model.setContactName(this._getContactName());
                    this.model.setContactEmail(this._getContactEmail());
                    if (this.canAddSeverity) {
                        this.model.setSeverity(this._getSeverity());
                    }
                    this.channel.vent.trigger("TicketCreateView::ticket:save", this.model);
                }
            },

            _getContactPhone: function () {
                // we need to do a trick here since we remove al preceeding +...
                // if the values starts with non zero, we will add a preceeding +
                return this._getSanitizedValue(this.uiComponents.contactPhone);
            },

            _getContactName: function () {
                return this._getSanitizedValue(this.uiComponents.contactName);
            },

            _getContactEmail: function () {
                return this._getSanitizedValue(this.uiComponents.contactEmail);
            },

            _getSubject: function () {
                return this._getSanitizedValue(this.uiComponents.caseSubject);
            },

            _getVisibility: function () {
                return this.uiComponents.checkBoxVisibility.isChecked();
            },

            _getLabelAndTextFromPropertyContainer: function (field) {
                var text = "";
                text += this._getLabelTextFromField(field);
                text += "\n";
                text += this._getSanitizedValue(field);
                return text;
            },

            _getLabelAndTextFromDropdownMenu: function (dropdown) {
                var text = "";
                text += this._getLabelTextFromField(dropdown);
                text += "\n";
                text += dropdown.getValue();
                return text;
            },

            _getLabelTextFromField: function (field) {
                var text = "";
                var labelNode = (field && field.el && field.el.parentElement && field.el.parentElement &&
                field.el.parentElement.children && field.el.parentElement.children[0]) ? field.el.parentElement.children[0] : {};
                text += labelNode.innerText;
                return text;
            },


            _getSeverity: function () {
                return this.uiComponents.caseSeverityActionMenu.getValue();
            },

            /*
             setter getter and trigger
             */

            closeLoader: function () {
                this._closeLoader();
            },

            setLoader: function () {
                this._setLoader();
            },

            _getAttachmentsCollection: function () {
                if (!this.attachmentsCollection) {
                    this.attachmentsCollection = new AttachmentsCollection([],{ticketModel: this.model});
                }
                return this.attachmentsCollection;
            },

            _getStorageModel: function () {
                return this.storageModel;
            },

            _openChatTab: function () {
                this.channel.vent.trigger("TicketViewController::open:chat");
            },

            _triggerArticleSearch: function (encodedSearchTerm) {
                this.channel.vent.trigger("TicketCreateView::trigger:search", encodedSearchTerm);
            },

            _showArticleSuggestionsCollection: function (collection) {
                this.uiComponents.articleSuggestionsView.setCollection(collection);
            },

            _showArticleSuggestions: function () {
                this.uiComponents.articleSuggestionsView.unhideView();
            },

            _setLoader: function () {
                this._getLoader().render();
            },

            _closeLoader: function () {
                this._getLoader().close();
            },

            _getLoader: function () {
                if (!this.loader) {
                    this.loader = new Loader({
                        permutation: Loader.PERMUTATION.L,
                        el: this.ui.loaderContainer,
                        zIndex: 2
                    });
                }
                return this.loader;
            },

            //--- Dropdown Menu for preceding changes
            _getPrecedingDropdownMenuCollection: function () {
                var itemsArr = _.map(PRECEEDING_DROPDOWN_MENU_ITEMS, function (itemId) {
                    return {
                        key: itemId,
                        value: LE.translator.translate("LEFramework.global.captions." + itemId)
                    };
                });
                this.precedingDropdownCollection = new Dropdown.Collection(itemsArr);
                return this.precedingDropdownCollection;
            },
            //--- Dropdown Menu for case severity
            _getSeverityDropdownMenuCollection: function () {
                var itemsArr = _.map(SEVERITY_DROPDOWN_MENU_ITEMS, function (itemId) {
                    return {
                        key: itemId,
                        value: LE.translator.translate("LEConnection.cases.createView.severity." + itemId),
                        tooltipTitle: LE.translator.translate("LEConnection.cases.createView.severity.tooltip." + itemId),
                        tooltipPosition: Dropdown.TOOLTIP_POSITION.BOTTOM
                    };
                });
                this.severityDropdownCollection = new Dropdown.Collection(itemsArr);
                return this.severityDropdownCollection;
            },

            _getTopicDropdownMenuCollection: function () {
                var itemsArr = _.map(CASE_TOPIC_DROPDOWN_ITEMS, function (itemId) {
                    return {
                        key: itemId,
                        value: LE.translator.translate("LEConnection.cases.createView.topic." + itemId) // todo add proper translation in languino
                    };
                });
                this.topicDropdownCollection = new Dropdown.Collection(itemsArr);
                return this.topicDropdownCollection;
            },

            _getPlatformDropdownMenuCollection: function () {
                var itemsArr = _.map(CASE_PLATFORM_DROPDOWN_ITEMS, function (itemId) {
                    return {
                        key: itemId,
                        value: LE.translator.translate("LEConnection.cases.createView.platform." + itemId) // todo add proper translation in languino
                    };
                });
                this.platformDropdownCollection = new Dropdown.Collection(itemsArr);
                return this.platformDropdownCollection;
            },

            _showSeverityDropdownMenu: function () {
                $(this.ui.caseSeverityActionMenuContainer).removeClass("hide");
            },

            _hidePrecedingChangesTextField: function () {
                $(this.ui.casePrecedingChangesContainer).addClass("hide");
                this.uiComponents.casePrecedingChangesInput.setValue("");
                this._onPrecedingChangesBlur();
            },

            _showPrecedingChangesTextField: function () {
                $(this.ui.casePrecedingChangesContainer).removeClass("hide");
            },

            _closeWindow: function () {
                this.channel.vent.trigger("TicketViewController::window:close");
            }

        });
    });
    return TicketCreateView;
});
